export default "__VITE_ASSET__b3924ad8__"